'use client'

import styled from 'styled-components'

import logoPic from '@/src/shared/assets/media/logo-white.png'
import {Image} from '@/src/shared/ui/image'
import {Link} from '@/src/shared/ui/link'

const Wrapper = styled.div`
  min-width: 92px;
`

interface LogoProps {
  src: string
}

const Logo = (props: LogoProps) => {
  return (
    <Wrapper>
      <Link href="/" {...props} asChild>
        <Image alt="Лого" src={logoPic} width={131} height={52} data-logo quality={100} />
      </Link>
    </Wrapper>
  )
}

export default Logo
